import { render, staticRenderFns } from "./appr-coring.vue?vue&type=template&id=4cb93404&scoped=true"
import script from "./appr-coring.vue?vue&type=script&lang=js"
export * from "./appr-coring.vue?vue&type=script&lang=js"
import style0 from "./appr-coring.vue?vue&type=style&index=0&id=4cb93404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb93404",
  null
  
)

export default component.exports